import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue')
  },
  {
    path: '/post/:id',
    name: 'Post',
    component: () => import('@/views/Post.vue')
  },
  {
    path: '/ideias',
    name: 'Ideas',
    component: () => import('@/views/Ideas.vue')
  },
  {
    path: '/ideias/:id',
    name: 'ideias by id',
    component: () => import('@/views/Post.vue')
  },
  {
    path: '/acoes',
    name: 'Acoes',
    component: () => import('@/views/Acoes.vue')
  },
  {
    path: '/acoes/:id',
    name: 'acoes by id',
    component: () => import('@/views/Post.vue')
  },
  {
    path: '/page/:name',
    name: 'page by id',
    component: () => import('@/views/Post.vue')
  },
  {
    path: '/salvos',
    name: 'Salvos',
    component: () => import('@/views/Salvos.vue')
  },
  {
    path: '/perfil',
    name: 'Perfil',
    component: () => import('@/views/Perfil.vue')
  },
  {
    path: '/jornada',
    name: 'Jornada',
    component: () => import('@/views/Jornada.vue')
  },
  {
    path: '/jornada/quiz',
    name: 'Jornada com Quiz',
    component: () => import('@/views/Jornada.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Registrar.vue')
  },
  {
    path: '/bonus/:id',
    name: 'bonus by id',
    component: () => import('@/views/Bonus.vue')
  },
  {
    path: '/recompensa/:id',
    name: 'recompensa by id',
    component: () => import('@/views/Bonus.vue')
  },
  {
    path: '/recuperar',
    name: 'Recuperar',
    component: () => import('@/views/Recuperar.vue')
  },
  {
    path: '/recuperar/:token',
    name: 'Recuperar by token',
    component: () => import('@/views/Recuperar.vue')
  },
  {
    path: '/ativar/:token',
    name: 'ativar',
    component: () => import('@/views/Recuperar.vue')
  },
  {
    path: '/ativar/',
    name: 'ativar by token',
    component: () => import('@/views/Recuperar.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: '/conectameufuturo/',
  routes
})

export default router
